import { Notification as NotificationType } from "./types";
import { Notification } from "./Notification";
import styles from "./Notifications.module.css";

interface NotificationsProps {
  notifications: NotificationType[];
  onDismiss: (id: string) => void;
  timeout: number;
  label: string;
}

function Notifications({ label, ...props }: NotificationsProps) {
  const notifications = props.notifications.map((notification, index) => {
    return (
      <Notification
        index={index}
        key={notification.id}
        notification={notification}
        onDismiss={props.onDismiss}
        timeout={notification.timeout ?? props.timeout}
      />
    );
  });

  return (
    <section
      role="log"
      className={styles.root}
      data-test="notifications"
      aria-label={label}
    >
      {notifications}
    </section>
  );
}

export default Notifications;
